//here we are importing our Axios dependency
import axios from 'axios';
import Global from '../../global';
//import {getOfferingApi/*, getPlayerApi*/} from "../../config/kambi/api-config/kambi-config";
import { setAxiosInterceptors } from '../../utils/axios/axios-interceptors';

//here is where we are defining our custom axios instance.
//if all of your API routes come from the same location, or you are using a web proxy to hit the server, you can provide a base url
//you can also attach axios interceptors to custom axios instances as well

function getOfferingApiAxiosInstance(/*useProdApis*/) {

  const Agent = require('agentkeepalive');
  const { HttpsAgent } = require('agentkeepalive');
  const keepaliveHttpAgent = new Agent();
  const keepaliveHttpsAgent = new HttpsAgent();
  let axiosInstance = axios.create({
    //baseURL: baseURL,
    timeout: Global.config.axiosTimeout,
    httpAgent: keepaliveHttpAgent,
    httpsAgent: keepaliveHttpsAgent
  });
  //console.log(`base URL before ${axiosInstance.defaults.baseURL} although ${baseURL}`);
  setAxiosInterceptors(axiosInstance);
  //console.log(`base URL ${axiosInstance.defaults.baseURL}`);
  return axiosInstance;
}

function getPlayerApiAxiosInstance(/*brand, useProdApis*/) {
  const Agent = require('agentkeepalive');
  const { HttpsAgent } = require('agentkeepalive');
  const keepaliveHttpAgent = new Agent();
  const keepaliveHttpsAgent = new HttpsAgent();
  const axiosInstance = axios.create({
    //baseURL: baseURL,
    timeout: Global.config.axiosTimeout,
    httpAgent: keepaliveHttpAgent,
    httpsAgent: keepaliveHttpsAgent
  });

  //console.log(`base URL before ${axiosInstance.defaults.baseURL} although ${baseURL}`);
  setAxiosInterceptors(axiosInstance);
  //console.log(`base URL ${axiosInstance.defaults.baseURL}`);
  return axiosInstance;
}


function getExtendSessionAxiosInstance() {
  const Agent = require('agentkeepalive');
  const { HttpsAgent } = require('agentkeepalive');
  const keepaliveHttpAgent = new Agent();
  const keepaliveHttpsAgent = new HttpsAgent();
  const axiosInstance = axios.create({
    timeout: 2000,
    httpAgent: keepaliveHttpAgent,
    httpsAgent: keepaliveHttpsAgent
  });

  setAxiosInterceptors(axiosInstance);
  return axiosInstance;
}


export const OfferingApiAxiosInstance = (function () {
  let instance;

  return {
    get: function () {
      if (!instance) {
        instance = getOfferingApiAxiosInstance();
      }
      return instance;
    },
  };

})();

export const PlayerApiAxiosInstance = (function () {
  let instance;

  return {
    get: function () {
      if (!instance) {
        instance = getPlayerApiAxiosInstance();
      }
      return instance;
    },
  };

})();

export const ExtendSessionAxiosInstance = (function () {
  let instance;

  return {
    get: function () {
      if (!instance) {
        instance = getExtendSessionAxiosInstance();
      }
      return instance;
    },
  };

})();
